module.exports = __webpack_public_path__ + "static/img/vv3_04.762207c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/site/vv3_04.jpg
// module id = CT8S
// module chunks = 3